import Model from "./Model.js";

/**
 * A ledger entry domain model. Mainly a struct as the client just renders it.
 *
 * @param {string} spec.uniqueIdentifier - Unique id
 * @param {Date} spec.date - Date when the ledger entry happened
 * @param {string} spec.fiscalYearId - Id of the fiscal year impacted by this entry
 * @param {string} spec.number - Value of the entry
 * @param {string} spec.series - ????
 * @param {string} spec.text - Description of the entry
 * @param {boolean} spec.hasLinkedDocument - True if a document is linked to this entry
 */
export default class LedgerEntry extends Model {
	constructor(spec = {}) {
		super(spec);
		this._uniqueIdentifier = spec.uniqueIdentifier;
		this._date = spec.date;
		this._fiscalYearId = spec.fiscalYearId;
		this._number = spec.number;
		this._series = spec.series;
		this._text = spec.text;
		this._hasLinkedDocument = spec.hasLinkedDocument;
	}

	getDate() {
		return this._date;
	}

	getFiscalYearId() {
		return this._fiscalYearId;
	}

	getNumber() {
		return this._number;
	}

	getSeries() {
		return this._series;
	}

	getText() {
		return this._text;
	}

	hasLinkedDocument() {
		return !!this._hasLinkedDocument;
	}

	getUniqueIdentifier() {
		return this._uniqueIdentifier;
	}
}
